import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "turtlekids_lang"

export default class extends Controller {
  static targets = ["fr", "en", "frBtn", "enBtn"]

  connect() {
    const saved = localStorage.getItem(STORAGE_KEY) || "fr"
    this._setLang(saved)
  }

  switchFr() {
    this._setLang("fr")
  }

  switchEn() {
    this._setLang("en")
  }

  _setLang(lang) {
    localStorage.setItem(STORAGE_KEY, lang)

    // Show/hide instruction panels
    this.frTargets.forEach(el => el.classList.toggle("hidden", lang !== "fr"))
    this.enTargets.forEach(el => el.classList.toggle("hidden", lang !== "en"))

    // Update button styles
    if (this.hasFrBtnTarget) {
      this.frBtnTarget.classList.toggle("bg-emerald-600", lang === "fr")
      this.frBtnTarget.classList.toggle("text-white", lang === "fr")
      this.frBtnTarget.classList.toggle("bg-gray-200", lang !== "fr")
      this.frBtnTarget.classList.toggle("text-gray-700", lang !== "fr")
    }
    if (this.hasEnBtnTarget) {
      this.enBtnTarget.classList.toggle("bg-emerald-600", lang === "en")
      this.enBtnTarget.classList.toggle("text-white", lang === "en")
      this.enBtnTarget.classList.toggle("bg-gray-200", lang !== "en")
      this.enBtnTarget.classList.toggle("text-gray-700", lang !== "en")
    }
  }
}
